var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"log-wrapper"},[_c('a-table',{ref:"logTableRef",attrs:{"scroll":{ x: '100%', y: 540 },"components":_vm.components,"data-source":_vm.tableData,"columns":_vm.columns,"pagination":false,"rowKey":'id'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }